export const countryCodes = [
  { code: "+93", flag: "🇦🇫", label: "Afghanistan" },
  { code: "+355", flag: "🇦🇱", label: "Albania" },
  { code: "+213", flag: "🇩🇿", label: "Algeria" },
  { code: "+1-684", flag: "🇦🇸", label: "American Samoa" },
  { code: "+376", flag: "🇦🇩", label: "Andorra" },
  { code: "+244", flag: "🇦🇴", label: "Angola" },
  { code: "+1-264", flag: "🇦🇮", label: "Anguilla" },
  { code: "+672", flag: "🇦🇶", label: "Antarctica" },
  { code: "+1-268", flag: "🇦🇬", label: "Antigua & Barbuda" },
  { code: "+54", flag: "🇦🇷", label: "Argentina" },
  { code: "+374", flag: "🇦🇲", label: "Armenia" },
  { code: "+297", flag: "🇦🇼", label: "Aruba" },
  { code: "+61", flag: "🇦🇺", label: "Australia" },
  { code: "+43", flag: "🇦🇹", label: "Austria" },
  { code: "+994", flag: "🇦🇿", label: "Azerbaijan" },

  { code: "+1-242", flag: "🇧🇸", label: "Bahamas" },
  { code: "+973", flag: "🇧🇭", label: "Bahrain" },
  { code: "+880", flag: "🇧🇩", label: "Bangladesh" },
  { code: "+1-246", flag: "🇧🇧", label: "Barbados" },
  { code: "+375", flag: "🇧🇾", label: "Belarus" },
  { code: "+32", flag: "🇧🇪", label: "Belgium" },
  { code: "+501", flag: "🇧🇿", label: "Belize" },
  { code: "+229", flag: "🇧🇯", label: "Benin" },
  { code: "+1-441", flag: "🇧🇲", label: "Bermuda" },
  { code: "+975", flag: "🇧🇹", label: "Bhutan" },
  { code: "+591", flag: "🇧🇴", label: "Bolivia" },
  { code: "+387", flag: "🇧🇦", label: "Bosnia & Herzegovina" },
  { code: "+267", flag: "🇧🇼", label: "Botswana" },
  { code: "+55", flag: "🇧🇷", label: "Brazil" },
  { code: "+673", flag: "🇧🇳", label: "Brunei" },
  { code: "+359", flag: "🇧🇬", label: "Bulgaria" },

  { code: "+86", flag: "🇨🇳", label: "China" },
  { code: "+57", flag: "🇨🇴", label: "Colombia" },
  { code: "+506", flag: "🇨🇷", label: "Costa Rica" },
  { code: "+385", flag: "🇭🇷", label: "Croatia" },
  { code: "+420", flag: "🇨🇿", label: "Czech Republic" },

  { code: "+45", flag: "🇩🇰", label: "Denmark" },

  { code: "+20", flag: "🇪🇬", label: "Egypt" },

  { code: "+358", flag: "🇫🇮", label: "Finland" },
  { code: "+33", flag: "🇫🇷", label: "France" },

  { code: "+49", flag: "🇩🇪", label: "Germany" },
  { code: "+30", flag: "🇬🇷", label: "Greece" },

  { code: "+852", flag: "🇭🇰", label: "Hong Kong" },
  { code: "+36", flag: "🇭🇺", label: "Hungary" },

  { code: "+91", flag: "🇮🇳", label: "India" },
  { code: "+62", flag: "🇮🇩", label: "Indonesia" },
  { code: "+98", flag: "🇮🇷", label: "Iran" },
  { code: "+353", flag: "🇮🇪", label: "Ireland" },
  { code: "+972", flag: "🇮🇱", label: "Israel" },
  { code: "+39", flag: "🇮🇹", label: "Italy" },

  { code: "+81", flag: "🇯🇵", label: "Japan" },

  { code: "+965", flag: "🇰🇼", label: "Kuwait" },

  { code: "+60", flag: "🇲🇾", label: "Malaysia" },
  { code: "+52", flag: "🇲🇽", label: "Mexico" },

  { code: "+31", flag: "🇳🇱", label: "Netherlands" },
  { code: "+64", flag: "🇳🇿", label: "New Zealand" },
  { code: "+234", flag: "🇳🇬", label: "Nigeria" },

  { code: "+92", flag: "🇵🇰", label: "Pakistan" },
  { code: "+63", flag: "🇵🇭", label: "Philippines" },
  { code: "+48", flag: "🇵🇱", label: "Poland" },
  { code: "+351", flag: "🇵🇹", label: "Portugal" },

  { code: "+974", flag: "🇶🇦", label: "Qatar" },

  { code: "+7", flag: "🇷🇺", label: "Russia" },

  { code: "+966", flag: "🇸🇦", label: "Saudi Arabia" },
  { code: "+65", flag: "🇸🇬", label: "Singapore" },
  { code: "+27", flag: "🇿🇦", label: "South Africa" },
  { code: "+34", flag: "🇪🇸", label: "Spain" },
  { code: "+94", flag: "🇱🇰", label: "Sri Lanka" },
  { code: "+46", flag: "🇸🇪", label: "Sweden" },
  { code: "+41", flag: "🇨🇭", label: "Switzerland" },

  { code: "+971", flag: "🇦🇪", label: "UAE" },
  { code: "+44", flag: "🇬🇧", label: "United Kingdom" },
  { code: "+1", flag: "🇺🇸", label: "United States" },

  { code: "+84", flag: "🇻🇳", label: "Vietnam" },
];
